
import { useNavigate } from 'react-router-dom';

export default function OrderConfirmation() {
  const navigate = useNavigate();

  const orderDetails = {
    id: '#ORD-2024-001',
    total: 42.50,
    estimatedTime: '15-20 دقيقة',
    address: 'شارع الملك فهد، حي النخيل، الرياض'
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg p-6 w-full max-w-sm text-center">
        {/* أيقونة النجاح */}
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <i className="ri-check-line text-3xl text-green-600"></i>
        </div>

        {/* رسالة التأكيد */}
        <h2 className="text-2xl font-bold text-gray-800 mb-2">تم تأكيد طلبك!</h2>
        <p className="text-gray-600 mb-6">شكراً لك، سيتم تحضير طلبك وتوصيله في أقرب وقت</p>

        {/* تفاصيل الطلب */}
        <div className="bg-gray-50 rounded-lg p-4 mb-6">
          <div className="space-y-2">
            <div className="flex justify-between">
              <span className="text-gray-600">رقم الطلب:</span>
              <span className="font-medium">{orderDetails.id}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">المبلغ الإجمالي:</span>
              <span className="font-bold text-green-600">{orderDetails.total} ر.س</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">وقت التوصيل:</span>
              <span className="font-medium">{orderDetails.estimatedTime}</span>
            </div>
          </div>
        </div>

        {/* الأزرار */}
        <div className="space-y-3">
          <button
            onClick={() => navigate(`/track-order/${orderDetails.id.replace('#', '')}`)}
            className="w-full bg-green-500 text-white py-3 rounded-lg font-medium"
          >
            تتبع الطلب
          </button>
          <button
            onClick={() => navigate('/home')}
            className="w-full border border-gray-200 text-gray-600 py-3 rounded-lg font-medium"
          >
            العودة للرئيسية
          </button>
        </div>
      </div>
    </div>
  );
}
